import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { AgendamentoModel } from '@models/agendamento/agendamento.model';
import { BaseResourceService } from '@core/services/outros/base-resource.service';
import { ConsultaDisponibilidadeModel } from '@core/models/agendamento/consulta-disponibilidade.model';
import { HelpConfig } from '@config/help-config';
import { ReagendamentoModel } from '@core/models/agendamento/reagendamento.model';

@Injectable({
  providedIn: 'root'
})
export class AgendamentoService extends BaseResourceService<AgendamentoModel> {

  private readonly url = `${this.helpConfig.SCHEDULING_API}agendamentos`;

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig,
  ) {
    super(`${helpConfig.SCHEDULING_API}agendamentos`, injector);
  }

  cancelSchedule(scheduleId: number): Observable<null> {
    return this._httpClient.post<null>(`${this.url}/${scheduleId}/cancelar`, {});
  }

  checkAvailableRoom(params?: {[param: string]: any }): Observable<AgendamentoModel[]> {
    return this._httpClient.get<AgendamentoModel[]>(`${this.url}`, { params });
  }

  reschedule(params?: {[param: string]: any }): Observable<any> {
    return this._httpClient.post<any>(`${this.url}/reagendar`, params);
  }

  queryAllAvailable(params?: {[param: string]: string}): Observable<ConsultaDisponibilidadeModel[]> {
    return this._httpClient.get<ConsultaDisponibilidadeModel[]>(`${this.url}/consultadisponibilidade`, { params });
  }

  replacement(params?: {[param: string]: any}): Observable<ReagendamentoModel[]> {
    return this._httpClient.get<ReagendamentoModel[]>(`${this.url}/reposicao`, { params });
  }

  replacementBatch(query): Observable<ReagendamentoModel[]> {
    return this._httpClient.get<ReagendamentoModel[]>(`${this.url}/reposicao?${query}`);
  }

  replicar(id: number, resource: AgendamentoModel): Observable<AgendamentoModel> {
    return this._httpClient.post<AgendamentoModel>(`${this._url}/replicar/${id}`, resource);
  }

}
